import JoinCalss from './app.vue'

function install(Vue) {
  function dialog(options = {}) {
    return new Promise((resolve, reject) => {
      const constructor = Vue.extend(JoinCalss)
      const JoinCalssDia = new constructor({
        el: document.createElement('div')
      })
      for (let key in options) {
        JoinCalssDia[key] = options[key]
      }
      JoinCalssDia.resolve = resolve
      JoinCalssDia.reject = reject
      document.body.appendChild(JoinCalssDia.$el)
    })
  }
  let heart_time = ''
  let token = new Date().getTime()
  let heartBeat = {
    startTime: function(params) {
      fetch(`${localStorage.getItem('zyUrl')}/api/passport/loginHeart?token=${token}`, {
        method: 'POST',
        credentials: 'include'
      })
        .then(data => {
          heart_time = setTimeout(() => {
            heartBeat.startTime()
          }, 300000)
        })
        .catch(e => {
          console.log(e)
        })
    },
    stopTime: function(params) {
      clearTimeout(heart_time)
    }
  }

  Vue.prototype.$queueUp = dialog
  Vue.prototype.$heartBeat = heartBeat
}
export default {
  install
}



// WEBPACK FOOTER //
// ./src/components/Stu/queueUp/index.js